import { render, staticRenderFns } from "./FlowStep.vue?vue&type=template&id=16dd31ae"
import script from "./FlowStep.vue?vue&type=script&lang=js"
export * from "./FlowStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16dd31ae')) {
      api.createRecord('16dd31ae', component.options)
    } else {
      api.reload('16dd31ae', component.options)
    }
    module.hot.accept("./FlowStep.vue?vue&type=template&id=16dd31ae", function () {
      api.rerender('16dd31ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/flowable/components/FlowStep.vue"
export default component.exports